import React, { useState, useEffect } from "react";
import Modal from "components/modal";

const NiveauFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  initialNiveau,
  isEditing,
  existingNiveaux = [],
  loading,
}) => {
  const [niveau, setNiveau] = useState({
    name_niveau: "",
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && initialNiveau) {
      setNiveau({
        name_niveau: initialNiveau.name_niveau || "",
      });
      setValidationErrors({});
    }
  }, [isOpen, initialNiveau]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNiveau({
      ...niveau,
      [name]: value,
    });

    if (validationErrors[name]) {
      setValidationErrors({
        ...validationErrors,
        [name]: null,
      });
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!niveau.name_niveau.trim()) {
      errors.name_niveau = "Le nom du niveau est requis";
    } else if (
      !isEditing &&
      existingNiveaux.some(
        (n) => n.name_niveau.toLowerCase() === niveau.name_niveau.toLowerCase()
      )
    ) {
      errors.name_niveau = "Ce nom de niveau existe déjà";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setSubmitting(true);

    const result = await onSubmit({
      name_niveau: niveau.name_niveau,
    });

    if (!result.success) {
      setValidationErrors(result.errors || {});
    }

    setSubmitting(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="md">
      <div className="text-center sm:text-left">
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-800">
            {isEditing ? "Modifier le niveau" : "Créer un nouveau niveau"}
          </h3>
          <div className="mt-2 h-1 w-12 rounded-full bg-[#57A863]"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="name_niveau"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Nom du niveau
            </label>
            <input
              type="text"
              name="name_niveau"
              id="name_niveau"
              value={niveau.name_niveau}
              onChange={handleInputChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
              placeholder="Ex: Licence 1, Master 2..."
            />
            {validationErrors.name_niveau && (
              <p className="mt-1.5 text-sm text-red-600">
                {validationErrors.name_niveau}
              </p>
            )}
          </div>

          {validationErrors.general && (
            <div className="rounded-md border border-red-200 bg-red-50 p-3">
              <p className="text-sm text-red-600">{validationErrors.general}</p>
            </div>
          )}

          <div className="mt-8 flex justify-end gap-3">
            <button
              type="button"
              className="rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-600 transition-colors hover:bg-gray-50"
              onClick={onClose}
              disabled={submitting || loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="rounded-md bg-[#57A863] px-4 py-2 text-white shadow-sm transition-colors hover:bg-[#4c9657]"
              disabled={submitting || loading}
            >
              {submitting || loading ? (
                <span className="flex items-center">
                  <svg
                    className="-ml-1 mr-2 h-4 w-4 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Chargement...
                </span>
              ) : isEditing ? (
                "Mettre à jour"
              ) : (
                "Créer"
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default NiveauFormModal;
